import { render } from "./AccordionItem.vue?vue&type=template&id=7fde49a2"
import script from "./AccordionItem.vue?vue&type=script&lang=js"
export * from "./AccordionItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__